<template>
<div>
  <section class="subHeader">
    <div class="invisible"></div>
    <h2>{{ nombre }}</h2>
    <XCerrar/>
  </section>
</div>
</template>

<script>
import XCerrar from './XCerrar.vue'
export default {
  components: { XCerrar },
  name: 'SubHeader',
  props: ['nombre', 'color', 'precedente']
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.subHeader {
  height: 8vh;
  background-color: var(--az-me-tr07);
  color: rgb(255, 255, 255);
  display: grid;
  grid-template-columns: 1fr 80vw;
  align-items:center;
  justify-items: left;
  /* border: solid 0.5px rgb(183, 248, 3); */
}
.subHeader{ /* */
  z-index: 10;
  box-shadow: rgb(2, 2, 2) 0px 0px 15px;
  position: relative;
}
.subHeader h2 {
  font-weight: bold;
  color: var(--na);
  padding-left: 18px;
  /* border: solid 0.5px rgb(248, 150, 3); */
}
@media screen and (max-width: 575px){
  .invisible{
    display: none
  }
  .X_cerrar{
    top: 0.9vh;
  }
  .subHeader {
    display: flex;
    align-items: center;
    justify-items: left;
    height: 7vh;
  }
  .subHeader h2 {
    /* border: solid 0.5px rgb(248, 150, 3); */
    padding-bottom: 6px;
    text-align: center;
    font-weight: 200;
  }
}
@media screen and (max-width: 370px){
   .X_cerrar{
    top: 0.4vh;
    font-size: 32px;
  }
  .subHeader h2 {
    padding-bottom: 2px;
  }
}
</style>
